import React from "react";
import { useFocusArray } from "../../../../../hooks/genericRefs";
import "./styles.css";

const CodeInput = ({
    code,
    onUpdateCode,
    codeLength,
}) => {
    const inputFocusControlArray = useFocusArray(codeLength);

    const onUpdateValue = (updateEvent, inputIndex) => {
        const targetValue = updateEvent.target.value;

        // Backspaces are handled by the OnKeyDown event
        if (targetValue.length) {
            onUpdateCode((prevValue) => {
                let newValue;
                newValue = prevValue + targetValue;
                newValue = newValue.substring(0, codeLength);
                return newValue;
            });
            const newTargetInputIndex = Math.min(codeLength - 1, inputIndex + 1)
            inputFocusControlArray[newTargetInputIndex].setFocus();
        }
    };

    const onKeyDown = (keyDownEvent) => {
        if (keyDownEvent.key === "Backspace") {
            onUpdateCode((prevValue) => {
                if (prevValue.length) {
                    inputFocusControlArray[prevValue.length - 1].setFocus();
                    return prevValue.substring(0, prevValue.length - 1);
                }
                return prevValue;
            });
        }
    };

    const onClickInputField = () => {
        const targetInputIndex = code === "" 
            ? 0 
            : Math.min(codeLength - 1, code.length);

        inputFocusControlArray[targetInputIndex].setFocus();
    };

    const generateInputBoxes = () => {
        const inputBoxes = [];
        for (let i = 0; i < codeLength; i += 1) {
            inputBoxes.push(
                <input
                    className="numberInput"
                    id={`position${i + 1}`}
                    key={`position${i + 1}`}
                    value={code.length > i ? code.charAt(i) : ""}
                    onChange={(event) => onUpdateValue(event, i)}
                    ref={inputFocusControlArray[i].elementRef}
                    onClick={onClickInputField}
                    onKeyDown={onKeyDown}
                    autoComplete="off"
                />
            );
        }
        return inputBoxes;
    };

    return (
        <div className="codeInputWrapper">
            {generateInputBoxes()}
        </div>
    );
};

export default CodeInput;
